// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__1MhAa","collapsed":"collapsed__16M5k"};